<template>
  <section class="page-reviews">
    <!-- HEADER -->
    <section class="hero-small">
      <div>
        <h1>Les avis clients Maisons Alysia</h1>
      </div>
    </section>
    <section class="reviews">
      <div class="grid-container">
        <div class="list" v-if="reviews && infos">
          <div>
            <div class="resume">
              <h2>Les avis certifiés de nos clients</h2>
              <p>
                Chez Maisons Alysia, ce sont <strong>nos clients</strong> qui parlent le mieux de leur expérience. Découvrez leurs <strong>avis vérifiés et authentiques</strong> sur la construction de leur maison. Tous nos témoignages sont certifiés par <strong>Immodvisor</strong>, un organisme indépendant garantissant la fiabilité des retours.
              </p>
              <p>
                Votre <strong>satisfaction est notre priorité </strong> vos retours nous aident à améliorer nos services et à mieux répondre à leurs attentes. Inspirez-vous de leurs parcours pour faire le bon choix.
              </p>
              <review-certification text="Note globale" :rating="infos.brandRating" />
              <div class="tags">
                <span>
                  <strong>{{ agencies.length }} </strong>
                  <small>agences</small>
                </span>
                <span>
                  <strong>{{ infos.brandReviewsCount }} </strong>
                  <small>avis certifiés</small>
                </span>
                <span>
                  <small>Excellent </small>
                  <strong>⭐️ ⭐️ ⭐️ ⭐️ ⭐️</strong>
                </span>
              </div>
            </div>

            <router-link v-for="review in reviews.slice(0,Math.floor(reviews.length / 2))" :key="review.id" :to="{ name: 'reviews-agency', params: { slugName: review.agency.slugName }}">
              <review-card  :review="review"/>
            </router-link>
          </div>
          <div>
            <router-link v-for="review in reviews.slice(Math.floor(reviews.length / 2), reviews.length)" :key="review.id" :to="{ name: 'reviews-agency', params: { slugName: review.agency.slugName }}">
              <review-card :review="review"/>
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import agencyApi from '@/services/api/agency';
import ReviewCard from './ReviewCard.vue';
import ReviewCertification from './ReviewCertification.vue';

const { VUE_APP_BRAND_ID } = process.env;
const brandId = VUE_APP_BRAND_ID;

export default {
  name: 'page-reviews',
  components: {
    ReviewCard,
    ReviewCertification,
  },
  data() {
    return {
      agencies: null,
      infos: null,
      reviews: null,
    };
  },
  async created() {
    await this.getAgencies();
  },
  methods: {
    async getAgencies() {
      try {
        const response = await agencyApi.fetchAll(brandId);
        this.agencies = response;

        const reviewsPromises = {};
        this.agencies.forEach((agency) => {
          reviewsPromises[agency.agencyId] = agencyApi.getAgencyReviews(agency.agencyId);
        });

        const results = await Promise.allSettled(Object.values(reviewsPromises));

        let reviews = [];
        results.forEach((result, index) => {
          if (result.status === 'fulfilled' && result.value.reviews) {
            const agencyId = Object.keys(reviewsPromises)[index];

            reviews = reviews.concat(result.value.reviews.filter((r) => r.rating > 2).slice(0, 5).map((review) => {
              review.agency = this.agencies.find((a) => a.agencyId === agencyId);

              return review;
            }));

            this.infos = {
              brandRating: result.value.brandRating,
              brandReviewsCount: result.value.brandReviewsCount,
            };
          }
        });

        this.reviews = this.shuffleArray(reviews);
      } catch (error) {
        this.$notification.show({ text: 'Une erreur s’est produite.' });
        throw error;
      }
    },
    async getReviews(agencyId) {
      try {
        const response = await agencyApi.getAgencyReviews(agencyId);
        this.infos = {
          agencyRating: response.agencyRating,
          agencyReviewsCount: response.agencyReviewsCount,
          brandRating: response.brandRating,
          brandReviewsCount: response.brandReviewsCount,
        };
        this.reviews = response.reviews;
      } catch (error) {
        this.$notification.show({ text: 'Une erreur s’est produite.' });
        throw error;
      }
    },
    shuffleArray(array) {
      const arr = array.slice();
      for (let i = arr.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
      }
      return arr;
    },
  },
};
</script>

<style lang="sass">
.page-reviews
  background: $medium-bg
  .hero-small
    @include hero-small
    background-image: linear-gradient(180deg, rgba(10, 10, 10, 0.6) 0%, rgba(32, 32, 32, 0.2) 100%), url(~@/assets/img/pages/reviews/family.jpg)
    h1
      text-wrap-style: pretty
  .reviews
    min-height: 2000px
    padding: 40px 0 100px
    background: linear-gradient(-15deg, lighten($primary, 20%), lighten($home-bg, 20%))
  .list
    display: flex
    gap: 30px
    padding: 40px
    @media (max-width: 768px)
      flex-direction: column
    > div
      display: flex
      flex: 1
      flex-direction: column
      gap: 30px
    a
      text-decoration: none !important
      transition: all ease-in 0.2s
      &:hover
        transform: scale(1.01)
    .resume
      position: relative
      display: flex
      flex-direction: column
      gap: 20px
      padding-bottom: 10px
      h2
        font-size: 3rem
        line-height: 120%
        color: $primary
        text-wrap: balance
      p
        color: $black
      .tags
        display: flex
        gap: 10px
        margin: 10px 0 20px
        @media (max-width: 768px)
          flex-direction: column
          > span
            text-align: center
        > span
          padding: 5px 15px
          border-radius: 20px
          background: #fd4e2a
          color: white
          font-size: 0.9rem
          &:last-child
            background: $colored-bg
          &:first-child
            background: $primary
</style>
